import { Context } from './context'

// TODO: These should be API calls

const regular = 0
const knowledgeBase = 1
const ideation = 2
const news = 3

export async function getCategories (ctx: Context) {
  const { prismaClient, userPermissions } = ctx
  const categories = await prismaClient.forum.findMany({
    where: {
      AND: [
        {
          status: { not: 'purged' }
        },
        {
          OR: [
            {
              type: { in: [regular, knowledgeBase, ideation, news] }
            }, {
              type: null
            }
          ]
        },
        {
          forumid: { in: userPermissions.readableCategories }
        }
      ]
    },
    orderBy: {
      displayorder: 'asc'
    },
    select: {
      title: true,
      forumid: true,
      threadcount: true,
      displayorder: true,
      type: true,
      forum: {
        select: {
          title: true,
          forumid: true,
          threadcount: true,
          displayorder: true,
          type: true
        }
      }
    }
  })

  return categories
}
